export default function (app) {
	app.factory('HintService', ['ajax', '$q', 'BaseService', 'pageContext', function (ajax, $q, BaseService, pageContext) {
		var factory = {};


		/**
		 * Order érték alapján sorba rendezi a bejövő hinteket.
		 * @param incomingData array
		 * @return array
		 */
		function sortIncomingHints(incomingData) {
			var sortedByOrder = [];
			if (incomingData.length > 0) {
				sortedByOrder = incomingData.sort(function (a, b) {
					return a.order > b.order ? 1 : b.order > a.order ? -1 : 0;
				});
			}
			return sortedByOrder;

		}

		/**
		 * Belső értékadás
		 */
		var hintsFromPageContext = sortIncomingHints(pageContext.hints);

		/**
		 * Visszaadja az összes hintet
		 */
		factory.getHints = function () {
			return hintsFromPageContext;
		};

		/**
		 * Visszaadja a hint Neve alapján az indexét
		 * @param hintName string
		 * @return object
		 */
		factory.getHintIndexByName = function (hintName) {
			var hintsLength = hintsFromPageContext.length;
			var hint = 0;
			for (var i = 0; i < hintsLength; i++) {
				if (hintName == hintsFromPageContext[i].hintId) {
					hint = i;
					break;
				}
			}
			return hint;
		};

		/**
		 * Visszaadja a hint Neve alapján a hintet
		 * @param hintName string
		 * @return object
		 */
		factory.getHintByName = function (hintName) {
			var hintsLength = hintsFromPageContext.length;
			var hint = {};
			for (var i = 0; i < hintsLength; i++) {
				if (hintName == hintsFromPageContext[i].hintId) {
					hint = hintsFromPageContext[i];
					break;
				}
			}
			return hint;
		};
		/**
		 * Nézettre állítja a paraméterben kapott indexű elemet
		 * @param index integer
		 */
		factory.setShown = function (index) {

			var params = {
				urlParameters: {
					pageid: hintsFromPageContext[index].page,
					hintid: hintsFromPageContext[index].hintId
				}
			};
			BaseService.createPromise('removeHint', params)
				.then(function () {
					hintsFromPageContext[index].needToDisplay = false;
				});

		};

		/**
		 * Nézettre állítja az összes elemet
		 */
		factory.setAllShown = function () {
			var params = {
				urlParameters: {
					pageid: hintsFromPageContext[0].page
				}
			};
			BaseService.createPromise('removeAllHints', params)
				.then(function () {
					for (var i = 0; i < hintsFromPageContext.length; i++) {
						hintsFromPageContext[i].needToDisplay = false;
					}
				});
		};

		/**
		 * Beállítja az 'aktuálisan mutatva' flaget
		 * @param index integer
		 */
		factory.setShowing = function (index) {
			hintsFromPageContext[index].isShowing = true;

		};


		/**
		 * Megvizsgálja, hogy épp mutatás alatt van-e elem
		 */
		factory.isShowing = function () {
			var checked = false;
			var hintsLength = hintsFromPageContext.length;
			for (var i = 0; i < hintsLength; i++) {
				if (hintsFromPageContext[i].isShowing) {
					checked = true;
				}
			}
			return checked;
		};


		return factory;
	}]);
};
